<script>import { getRandomId } from "../../utils/get-random-id";
import { twMerge } from "tailwind-merge";
import { base, input } from "./common";
import FloatingLabel from "./floating-label.svelte";
export let element = void 0;
let className = void 0;
export { className as class };
export let label;
export let id = getRandomId();
export let error = false;
export let value = void 0;
</script>

<div class={twMerge('relative', className)}>
  <select
    bind:this={element}
    bind:value
    on:change
    on:mouseenter
    on:mouseleave
    on:click
    on:focus
    on:blur
    {id}
    class={twMerge(
      base({ error }),
      input({ size: 'lg' }),
      'peer select-chevron',
      value ? 'pb-2 pt-6' : 'text-transparent'
    )}
    {...$$restProps}
  >
    <slot />
  </select>
  <FloatingLabel for={id} resting={!value} {error}>{label}</FloatingLabel>
</div>
